import React, { Component, Fragment } from 'react';
import { Card, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Spinner from 'react-bootstrap/Spinner';
import historyReportThree from './HistoryReportThree';

class HistoryFormThree extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            resumen: this.props.history.motivo_consulta != null && this.props.history.motivo_consulta != undefined ? this.props.history.motivo_consulta : null,
            audiologia: this.props.history.descripcion != null && this.props.history.descripcion != undefined ? this.props.history.descripcion : null,
            age: '',
            profile: {},
            plans: [],
            planName: '',
            idPlan: '',
            urlLogo: '',            
            loading: true,
            exist: false,
            disableInput: false,
            onUpdate: false
        }
    }

    componentDidMount() {

        this.getDataHistory();
    }

    getDataHistory = () => {

        if (this.props.dataHistory.length > 0) {

            const data = this.props.dataHistory;

            for (let i = 0; i < data.length; i++) {
                if (data[i].tipo_informe === 3) {

                    this.setState({
                        loading: false,
                        id_informe: data[i].id_hist_informes,
                        resumen: data[i].motivo_consulta,
                        audiologia: data[i].resultados,
                        exist: true,
                        disableInput: true
                    })
                }else if((i+1) === data.length){
                    this.setState({ loading: false });
                }
            }
        }else{
            this.setState({ loading: false });
        }    
    }

    generteReportPdf = async () => {

        const dataReport = {
            resumen: this.state.resumen,
            audiologia: this.state.audiologia,
            observaciones: this.props.history.observaciones,
            names: this.props.data.nombres,           
            age: this.props.age,//this.state.age,
            plan: this.props.planName, //this.state.planName,
            ocupation: this.props.data.ocupacion !== null ? this.props.data.ocupacion :'',
            id_historia: this.props.data.id_historia,
            documentNumber: this.props.data.num_documento,
            telephone: this.props.data.telephone !== null ? this.props.data.telephone : '',
            address: this.props.data.adress.direccion !== null ? this.props.data.adress.direccion: '',
            remitente: this.props.data.remitente,
            fecha: this.props.data.fecha,
            hora: this.props.data.fecha_ingreso_completa,

        };

        historyReportThree(dataReport);
    }

    saveData = async () => {

        if (this.state.observaciones === '')
            this.setState({ observaciones: this.props.history.observaciones });

        //Descripcion - Interpretacion
        const dataToSend = {
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.resumen,
            procedimiento: '',
            parametro_estimulacion: '',
            resultados: this.state.audiologia,
            procedimiento: '',
            interpretacion: '',
            observacion: this.props.history.observaciones,
            recomendaciones: '',
            conclusion: "",
            nota: "",
            fecha: this.props.data.fecha, //moment(new Date(this.props.data.fecha)).format("YYYY-MM-DD"),
            id_servicio: null,
            tipo_informe: 3,
            antecedentes_paciente: null,
            lengua_payne: null,
            observacion2: null,
            mioescanografia: null
        }

        console.log(dataToSend);

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status !== 500 && response.status !== 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.generteReportPdf().then(() => {
                    //window.location.reload();
                    this.setState({ disableInput: true });
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                //reject(error)
            });
    }

    updateData = () => {

        //Descripcion - Interpretacion
        const dataToSend = {
            id_hist_informes: this.state.id_informe,
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.resumen,
            procedimiento: '',
            parametro_estimulacion: '',
            resultados: this.state.audiologia,
            procedimiento: '',
            interpretacion: '',
            observacion: this.props.history.observaciones,
            recomendaciones: '',
            conclusion: "",
            nota: "",
            fecha: this.props.data.fecha, //moment(new Date(this.props.data.fecha)).format("YYYY-MM-DD"),
            id_servicio: null,
            tipo_informe: 3,
            antecedentes_paciente: null,
            lengua_payne: null,
            observacion2: null,
            mioescanografia: null

        }


        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.makePdf().then(() => {
                    //window.location.reload();
                    this.setState({ disableInput: true, exist: true, onUpdate: false });
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                //reject(error)
            });
    }

    render() {

        return (
            <Card>
                {this.state.loading ?
                    <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>
                    :
                    <Fragment>
                        <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                            <div className="card__title">
                                <h5 className="bold-text">Resumen De Historia Clinica </h5>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Resumen de Historia Clinica </span>

                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-resum-history"
                                            defaultValue={this.state.exist ? this.state.resumen : this.props.history.motivo_consulta}
                                            onChange={(e) => { this.setState({ resumen: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Consulta Audiologica </span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-audiology"
                                            defaultValue={this.state.exist ? this.state.audiologia : this.props.history.descripcion}
                                            onChange={(e) => { this.setState({ audiologia: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <Button
                                    style={{ marginRight: 12, marginTop: 20 }}
                                    size="sm"
                                    color="primary"
                                    onClick={() => {

                                        if (this.state.exist)
                                            this.generteReportPdf();
                                        else
                                            this.saveData();
                                        ///this.generteReportPdf();
                                    }}
                                >
                                    {this.state.exist ? " Generar Reporte" : " Guardar y Generar Reporte"}

                                </Button>
                                {this.state.exist ?
                                    <Button
                                        style={{ marginTop: 20 }}
                                        size="sm"
                                        color="primary"
                                        onClick={() => {

                                            if (this.state.onUpdate)
                                                this.updateData();
                                            else
                                                this.setState({ disableInput: false, onUpdate: true });
                                        }}
                                    >
                                        {this.state.onUpdate ? "Actualizar" : " Habilitar Actualizacion"}
                                    </Button>
                                    : null}
                            </div>
                        </div>
                    </Fragment>}
            </Card>
        );
    }
}

export default reduxForm({
    form: 'history_form_three', // a unique identifier for this form
})(withTranslation('common')(HistoryFormThree));